import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';

@Injectable()

export class PaServiceService
  extends ServiceCRUD {
  private baseUrlService: string
  private url: string;
  constructor(http: HttpClient, router: Router) {
    super(http, router);
    this.baseUrlService = environment.URL_API
  }

  protected getURL(): string {
    return this.baseUrlService.concat('/').concat(this.url);
  }

  public itensCategoriaResumo() {
    this.url = 'pea';
  }

  public definirURLTotais() {
    this.url = 'pea';
  }

  public getTotais(marcas: object): Promise<any> {
    this.definirURLTotais();
    return this.listar([], marcas);
  }

}
